// src/utils/config.ts
export const IMAGE_BASE_PATH = "/assets/images/";
export const ICON_BASE_PATH = "/assets/icons/";
export const BANK_BASE_PATH = "/assets/bankname/";
export const FONT_BASE_PATH = "/assets/font/";
export const COUNTRY_BASE_PATH = "/assets/country/";
export const DATAJSON_BASE_PATH = "/assets/data/";
export const DATA_GIF_PATH = "/assets/animation/";
export const UAE_BANK_PATH = "/assets/uaebank/";
export const Account_PATH = "/assets/icons/";
export const BANK_LIST_PATH = "/assets/images/logos/bank/ae/";
export const SAN_ICON_BASE_PATH = "/assets/sanicon/";
export const QR_PATH = 'data:image/png;base64,';
